import React from "react";
import dayjs from "dayjs";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { ActivitiesFields } from "../../../pages/shippingView/types";
import { CheckCircle } from "@mui/icons-material";

interface Props {
  props: {
    route: string;
    title: string;
    createdAt: string;
    completeCallback?: () => void;
  };
}

const routToComplete = [
  "UNLOADING",
  "CUSTOMS",
  "WAREHOUSING",
  "DELIVERY",
  "INSURANCE",
];

const AddedShippingService: React.FC<Props> = ({ props }) => {
  const { route, title, createdAt, completeCallback } = props;
  const formattedDate = dayjs(createdAt).format("DD/MM/YYYY [at] HH.mm [p.m.]");
  const serviceRoute = ActivitiesFields[route as keyof typeof ActivitiesFields];
  return (
    <Paper sx={{ p: 2, borderRadius: "4px" }}>
      <Typography variant="body2" color="text.secondary">
        {formattedDate}
      </Typography>

      <Typography variant="subtitle1" fontWeight={600} mt={0.5} mb={1}>
        {title}
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Chip
          label={`Route - ${serviceRoute}`}
          size="small"
          sx={{ backgroundColor: "#eee" }}
        />
        {completeCallback && routToComplete.includes(route) && (
          <Tooltip title="Complete activity">
            <IconButton onClick={completeCallback} color="primary">
              <CheckCircle />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Paper>
  );
};

export default AddedShippingService;
